import React, {ReactNode} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Divider
} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import Loader from '@components/framework/loader/Loader';
import './FormDialog.scss';

interface IFormDialogProps {
  open: boolean;
  onClose: (res: 'confirm' | 'cancel') => void;
  children: ReactNode;
  title: ReactNode;
  cancelButtonText?: ReactNode;
  confirmButtonText?: ReactNode;
  description: ReactNode;
  subTitle: ReactNode;
  isSubmitting?: boolean;
  onSubmit: () => void;
  maxWidth?: DialogProps['maxWidth'];
}

const FormDialog = (props: IFormDialogProps): JSX.Element => {
  const {t} = useTranslation();
  const {
    open,
    title,
    description,
    subTitle,
    children,
    onClose,
    cancelButtonText = t('COMMON.CANCEL'),
    confirmButtonText = t('COMMON.SUBMIT'),
    isSubmitting = false,
    onSubmit,
    maxWidth = 'sm'
  } = props;
  const handleClose = (res: 'confirm' | 'cancel' = 'cancel') => {
    onClose(res);
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown={true}
      disableBackdropClick={true}
      maxWidth={maxWidth}
      fullWidth
      className="form-dialog">
      <DialogTitle disableTypography>{title}</DialogTitle>
      <DialogContent dividers className="form-dialog-content">
        {description && subTitle && (
          <div>
            <div className="form-description">{description}</div>
            <div className="form-subtitle">{subTitle}</div>
            <Divider />
          </div>
        )}
        {children}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose('cancel')}>
          {cancelButtonText}
        </Button>
        <Button
          variant={'contained'}
          disabled={isSubmitting}
          onClick={onSubmit}
          color="primary"
          type={'submit'}>
          {isSubmitting && <Loader />}
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FormDialog;
